export default __webpack_public_path__ + "static/media/Group9232.d8e75d7f.svg";